import { CSSProperties } from 'react';
import { createPortal } from 'react-dom';
import { DataItem } from './snapshot-chart-constants';

interface SnapshotChartTooltipContentProps {
  item: DataItem;
  style: CSSProperties;
  colorMap: Record<string, string>;
  valueFormatter: (value: number) => string;
}

export const SnapshotChartTooltipContent = ({
  item,
  style,
  colorMap,
  valueFormatter
}: SnapshotChartTooltipContentProps) => {
  const lowerBound = item.errorX ? item.value - item.errorX[0] : undefined;
  const upperBound = item.errorX ? item.value + item.errorX[1] : undefined;

  return createPortal(
    <div className='snapshot-tooltip' style={style}>
      <div className='header-label'>{item.name}</div>
      <div className='item-list'>
        {item.name !== 'Baseline' && lowerBound !== undefined && upperBound !== undefined && (
          <div className='item-row'>
            <div className='whiskers'>
              <div className='line' />
            </div>
            <div className='name'>Confidence Interval: </div>
            <div className='value'>{`${valueFormatter(lowerBound)} – ${valueFormatter(upperBound)}`}</div>
          </div>
        )}
        <div className='item-row'>
          <div className='square' style={{ backgroundColor: colorMap[item.name] }} />
          <div className='name'>{item.name === 'Baseline' ? 'Baseline: ' : 'Estimate: '}</div>
          <div className='value'>{valueFormatter(item.value)}</div>
        </div>
      </div>
    </div>,
    document.body
  );
};
